import { render } from "./JudgesPage.vue?vue&type=template&id=d82708ca"
import script from "./JudgesPage.vue?vue&type=script&lang=js"
export * from "./JudgesPage.vue?vue&type=script&lang=js"

import "./JudgesPage.vue?vue&type=style&index=0&id=d82708ca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__